<template>
  <div v-show="!isHideCoreTeam">
    <section class="core-team-section pc-core-team" id="core-team-section">
      <div class="core-team">
        <header class="core-team-header section-title-wrapper">
          <div class="title-left">
            <h1 class="section-title" v-text="$t('home.core_team_title')"></h1>
            <h2 class="section-sub-title" v-text="$t('home.core_team_sub_title')"></h2>
          </div>
        </header>
        <div class="core-team-content">
          <div class="swiper-container" id="coreTeamSwiper">
            <div class="swiper-wrapper core-teams">
              <div class="swiper-slide  swiper-no-swiping core-team-item" v-for="item in teamIntros" :key="item.id" :class="{'hide':item.id<firstSlide||item.id>lastSlide}">
                <div class="core-team-wrapper">
                  <img src="../../../assets/img/core_team_1.png" alt />
                  <div class="core-team-introduction">
                    <div class="intro">
                      <div class="intro-text" v-html="item.intro"></div>
                    </div>
                  </div>
                </div>
                <div class="core-team-name" v-text="item.name"></div>
                <div class="core-team-position" v-text="item.position"></div>
              </div>
            </div>
            <div id="coreTeamPrev"></div>
            <div id="coreTeamNext"></div>
          </div>
        </div>
      </div>
    </section>
    <div class="wap-coreTeam">
      <div class="coreTeam-container">
        <header class="wap-title-wrapper">
          <div class="wap-title-left">
            <div class="wap-section-title" v-text="$t('home.core_team_title')"></div>
            <div class="wap-section-sub-title" v-text="$t('home.core_team_sub_title')"></div>
          </div>
        </header>
        <div class="coreTeam-content">
          <div class="team-box" v-for="item in teamIntros" :key="item.id">
            <div class="team-bottom-box" @click.stop="showDes(item.id)">
              <div class="team-img" :class="'team-img'+item.id"></div>
              <div class="team-des" :class="{'show':showDesId==item.id}">
                <div class="team-des-text" v-html="item.intro"></div>
              </div>
            </div>
            <div class="team-position" v-text="item.position"></div>
            <div class="team-name" v-text="item.name"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { animationScroll } from '@/assets/js/common'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'

export default {
  data () {
    return {
      introShowIndex: '',
      firstSlide: 1,
      coreTeamSwiper: null,
      isHideCoreTeam: this.$i18n.t('core_team.hide_core_team'),
      teamIntros: [
        {
          id: '1',
          name: 'Zhang,Xuan',
          intro: this.$i18n.t('core_team.zhang_xuan_intro'),
          position: 'CEO'
        },
        {
          id: '2',
          name: 'Leo Yang',
          intro: this.$i18n.t('core_team.leo_yang_intro'),
          position: 'CPO'
        },
        {
          id: '3',
          name: 'Nep Yan',
          intro: this.$i18n.t('core_team.nep_yan_intro'),
          position: 'CTO'
        },
        {
          id: '4',
          name: 'Nep Yan',
          intro: this.$i18n.t('core_team.nep_yan_intro'),
          position: 'CTO'
        },
        {
          id: '5',
          name: 'Nep Yan',
          intro: this.$i18n.t('core_team.nep_yan_intro'),
          position: 'CTO'
        },
        {
          id: '6',
          name: 'Nep Yan',
          intro: this.$i18n.t('core_team.nep_yan_intro'),
          position: 'CTO'
        }
      ],
      showDesId: '',
      wapScrollTimer: null
    }
  },
  methods: {
    showIntro (index) {
      this.introShowIndex = index
    },
    hideIntro () {
      this.introShowIndex = ''
    },
    showDes (id) {
      var _this = this
      this.stopWapPreviewScroll()
      _this.showDesId = id
      var dom = $('.team-box')
        .eq(id - 1)
        .find('.team-des-text')
      _this.scrollWapIntro(dom)
    },
    hideDes () {
      this.stopWapPreviewScroll()
      this.showDesId = ''
    },
    stopWapPreviewScroll () {
      clearTimeout(this.wapScrollTimer)
      if (this.showDesId) {
        var previewDom = $('.team-box')
          .eq(this.showDesId - 1)
          .find('.team-des-text')
        previewDom.stop()
        previewDom.scrollTop(0)
      }
    },
    scrollWapIntro (dom) {
      this.wapScrollTimer = setTimeout(function () {
        var scrollHeight = dom.prop('scrollHeight')
        dom.animate({ scrollTop: scrollHeight }, 10000)
        dom.scroll(function () {
          // scroll at bottom
          if (dom.scrollTop() + dom.height() >= scrollHeight - 2) {
            dom.stop()
          }
        })
      }, 1000)
    },
    initCoreTeamSwiper () {
      var _this = this
      _this.coreTeamSwiper = new Swiper('#coreTeamSwiper', {
        autoplay: {
          delay: 3000
        },
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        disableOnInteraction: false,
        navigation: {
          nextEl: '#coreTeamNext',
          prevEl: '#coreTeamPrev'
        },
        on: {
         autoplay:function(){
           if (this.activeIndex===0) {
              _this.firstSlide=1
           }else{
             _this.firstSlide++;
           }
          },
        }
      })
    },
    eventListener () {
      var _this = this
      animationScroll($('.core-team'))// 页面滚动进入动画

      $('.core-team-item').mouseenter(function () { // 鼠标进入效果
        _this.coreTeamSwiper.autoplay.stop();
        var textDom = $(this).find('.intro-text')
        var scrollHeight = textDom.prop('scrollHeight')
        setTimeout(function () {
          textDom.animate({ scrollTop: scrollHeight }, 10000)
        }, 1000)
      })
      $('.core-team-item').mouseleave(function () { // 鼠标移出效果
        var textDom = $(this).find('.intro-text')
        textDom.stop()
        textDom.scrollTop(0)
        _this.coreTeamSwiper.autoplay.start();
      })

      $('#coreTeamPrev').click(function () {
        if (_this.firstSlide <= 1) {
          return
        }
        _this.firstSlide--
        _this.coreTeamSwiper.autoplay.start();
      })
      $('#coreTeamNext').click(function () {
        if (_this.lastSlide >= _this.teamIntros.length) {
          return
        }
        _this.firstSlide++
        _this.coreTeamSwiper.autoplay.start();
      })
    },
    initial () {
      this.initCoreTeamSwiper()
      if (this.isHideCoreTeam === 'true') {
        this.isHideCoreTeam = true
      } else {
        this.isHideCoreTeam = false
      }
      this.eventListener()
    }
  },
  mounted () {
    this.initial()
  },
  computed: {
    lastSlide () {
      return this.firstSlide + 3
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/coreTeamSection.vue